module.exports = __webpack_public_path__ + "static/media/Background3.add01b08.png";